import { render, staticRenderFns } from "./GymSpaceSelector.vue?vue&type=template&id=58ed4038&scoped=true"
import script from "./GymSpaceSelector.vue?vue&type=script&lang=js"
export * from "./GymSpaceSelector.vue?vue&type=script&lang=js"
import style0 from "./GymSpaceSelector.vue?vue&type=style&index=0&id=58ed4038&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ed4038",
  null
  
)

export default component.exports